<template>
  <div v-parallax-fit="parallax" class="painting" id="painting-1">
    <img src="/themes/rise-theme/dist/images/estate/character-view/holly/02_Book01.png" alt="">
  </div>
</template>

<script>
export default {
  data() {
    return {
      mutationObserver: null,
      parallax: [
        {
          start: 0,
          end: 400,
          fromStyle: { transform: 'translateX(-60%) translateY(-40%)', opacity: 0 },
          toStyle: { transform: 'translateX(-60%) translateY(-40%)', opacity: 1 },
          easing: 'linear'
        },
        {
          start: 400,
          end: 800,
          fromStyle: { transform: 'translateX(-60%) translateY(-40%)' },
          toStyle: { transform: 'translateX(-60%) translateY(-110%)', marginTop: '10px' },
          easing: 'linear'
        },
        {
          start: 800,
          end: 1200,
          fromStyle: { transform: 'translateX(-60%) translateY(-110%)' },
          toStyle: { transform: 'translateX(-60%) translateY(-140%)' },
          easing: 'linear'
        },
        {
          start: 1200,
          end: 1800,
          fromStyle: { transform: 'translateX(-60%) translateY(-140%)' },
          toStyle: { transform: 'translateX(-60%) translateY(-210%)' },
          easing: 'linear'
        },
        {
          start: 1800,
          end: 2200,
          fromStyle: { transform: 'translateX(-60%) translateY(-210%)', opacity: 1 },
          toStyle: { transform: 'translateX(-60%) translateY(-250%)', opacity: 0.5 },
          easing: 'linear'
        },
        {
          start: 2200,
          end: 2600,
          fromStyle: { transform: 'translateX(-60%) translateY(-250%)', opacity: 0.5 },
          toStyle: { transform: 'translateX(-60%) translateY(-300%)', opacity: 0 },
          easing: 'linear'
        }
      ]
    }
  },
  mounted() {
    const self = this;
    const evidence = {
      items: [
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/holly/evidence/2.png',
          url: 'https://www.amazon.com/Holly-Hook/e/B003VE3FIQ',
          link_title: {
			'en': "Holly's Amazon Store",
			'es': 'Tienda Amazon de Holly'
		  },
        }
      ],
      text: {
		'en': '',
		'es': ''
	  }
    };
    const text = {
		'en': "She dreams of being able to quit her day job and make a living from her writing.",
		'es': 'Ella sueña con poder dejar su trabajo diario y ganarse la vida con su escritura.'
	};

    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach(mutation => {
        if (mutation.target.style.marginTop == '10px') {
          self.$evidence.value = JSON.stringify(evidence);
          self.$readMore.value = text;
        }
      });
    });

    this.mutationObserver.observe(document.querySelector('#painting-1'), {
      attributes: true,
      attributeFilter: ['style']
    });
  },
  unmounted() {
    this.mutationObserver.disconnect();
  }
}
</script>

<style lang="scss" scoped>
.painting {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  max-width: 200px;
  transition: all 0.1s linear;
}

@media screen and (max-width: 1024px) {
  .painting {
    max-width: 120px;
  }
}

@media screen and (max-width: 650px) {
  .painting {
    max-width: 75px;
  }
}
</style>
